import { render, staticRenderFns } from "./Input_Decimal.vue?vue&type=template&id=067d86a2&"
import script from "./Input_Decimal.vue?vue&type=script&lang=js&"
export * from "./Input_Decimal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports